import React from 'react';

interface ColorPickerInputProps {
  label: string;
  value: string;
  onChange: (color: string) => void;
}

const ColorPickerInput: React.FC<ColorPickerInputProps> = ({ label, value, onChange }) => {
  return (
    <div className="flex items-center gap-3">
      <label className="text-sm text-gray-700 dark:text-gray-300 min-w-[140px]">{label}</label>
      <div className="flex items-center gap-2">
        <input
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          className="w-8 h-8 rounded border border-gray-300 dark:border-gray-600 cursor-pointer bg-transparent p-0"
        />
        <input
          type="text"
          value={value || ''}
          onChange={(e) => {
            const v = e.target.value;
            if (/^#[0-9a-fA-F]{0,6}$/.test(v) || v === '') onChange(v);
          }}
          placeholder="#000000"
          className="w-24 px-2 py-1 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white font-mono"
        />
      </div>
    </div>
  );
};

export default ColorPickerInput;
